import { render, staticRenderFns } from "./OfferDetail.vue?vue&type=template&id=73cde563&scoped=true&"
import script from "./OfferDetail.vue?vue&type=script&lang=ts&"
export * from "./OfferDetail.vue?vue&type=script&lang=ts&"
import style0 from "./OfferDetail.vue?vue&type=style&index=0&id=73cde563&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73cde563",
  null
  
)

export default component.exports